import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import unsplash from "../api/unsplash";
import GlobalSnackbar from "./Snackbar";
import LinearProgress from "@mui/material/LinearProgress";
import Switch from "@mui/material/Switch";

import {
  Grid,
  Box,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  Input,
  Divider,
  InputAdornment,
  ButtonGroup,
  Tooltip,
  FormControlLabel,
  Checkbox,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  DialogContentText,
  DialogActions,
  Autocomplete,
  Chip,
  Stack,
  Typography,
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";

import { IconButton } from "@mui/material";

import {
  DataGridPro,
  itIT,
  GridToolbar,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
  GridToolbarQuickFilter,
} from "../utils/PersistedDataGridPro";
import { CustomFooterPersonalized } from "../utils/CustomFooterPersonalized";

import {
  Add,
  Delete,
  Close,
  Check,
  MenuBook,
  Visibility,
  VisibilityOff,
  AutoFixHigh,
  LockReset,
} from "@mui/icons-material";

const getPasswordChecks = (password = "", username = "", email = "") => {
  const passwordNormalizzata = String(password || "");
  const passwordLower = passwordNormalizzata.toLowerCase();
  const usernameLower = String(username || "")
    .trim()
    .toLowerCase();
  const emailName = String(email || "")
    .split("@")[0]
    .trim()
    .toLowerCase();

  return {
    lunghezza: passwordNormalizzata.length >= 12,
    minuscola: /[a-z]/.test(passwordNormalizzata),
    maiuscola: /[A-Z]/.test(passwordNormalizzata),
    numero: /\d/.test(passwordNormalizzata),
    simbolo: /[^A-Za-z0-9\s]/.test(passwordNormalizzata),
    senzaSpazi:
      passwordNormalizzata.length > 0 && !/\s/.test(passwordNormalizzata),
    datiPersonali:
      passwordNormalizzata.length > 0 &&
      (!usernameLower ||
        usernameLower.length < 3 ||
        !passwordLower.includes(usernameLower)) &&
      (!emailName ||
        emailName.length < 3 ||
        !passwordLower.includes(emailName)),
  };
};

const generaPasswordSicura = () => {
  const gruppi = [
    "ABCDEFGHJKLMNPQRSTUVWXYZ",
    "abcdefghijkmnopqrstuvwxyz",
    "23456789",
    "!@#$%&*+-_=?",
  ];
  const tutti = gruppi.join("");
  const casuale = (caratteri) => {
    const valore = new Uint32Array(1);
    window.crypto.getRandomValues(valore);
    return caratteri[valore[0] % caratteri.length];
  };
  const password = [
    ...gruppi.map(casuale),
    ...Array.from({ length: 14 }, () => casuale(tutti)),
  ];

  for (let indice = password.length - 1; indice > 0; indice -= 1) {
    const valore = new Uint32Array(1);
    window.crypto.getRandomValues(valore);
    const altroIndice = valore[0] % (indice + 1);
    [password[indice], password[altroIndice]] = [
      password[altroIndice],
      password[indice],
    ];
  }
  return password.join("");
};

function CustomToolbarG() {
  return (
    <GridToolbarContainer
      sx={{
        px: 2,
        py: 1.25,
        bgcolor: "#FAFCFD",
        borderBottom: "1px solid #E4E9ED",
      }}
    >
      <GridToolbarQuickFilter
        placeholder="Cerca cliente..."
        sx={{
          width: { xs: "100%", sm: 300 },
          "& .MuiInput-root": {
            px: 1.5,
            py: 0.5,
            border: "1px solid #CFD8DC",
            borderRadius: 1.5,
            bgcolor: "white",
          },
          "& .MuiInput-root:before, & .MuiInput-root:after": {
            display: "none",
          },
        }}
      />
    </GridToolbarContainer>
  );
}

let newUtenteCliente = {
  Username: "",
  Password: "",
  Tipo: 4,
  Medico: null,
  Cliente: 0,
  Attivo: 1,
  VisualizzaScadenzeWeb: 0,
};
const UtentiClienti = () => {
  const [utentiClienti, setUtentiClienti] = useState([]);
  const [utentiClientiVisibili, setUtentiClientiVisibili] = useState([]);
  const [loading, setLoading] = useState(true);
  const [vistaUtenteCliente, setVistaUtenteCliente] = useState([]);

  const [filtro, setFiltro] = useState({
    attivo: true,
    disattivo: false,
  });
  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [snack, setSnack] = useState({
    severity: "success",
    messaggio: "Salvataggio Effettuato correttamente",
    open: false,
  });
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };

  const columns = [
    {
      filterable: false,
      sortable: false,
      field: "Actions",
      headerName: "Azioni",
      width: 84,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => (
        <Stack direction="row" justifyContent="flex-start">
          <NewUtenti
            id="edit"
            utenteCliente={params.row}
            saveFunction={handleSave}
            title="Modifica Utente"
            snack={snack}
            openSnack={openSnack}
            handleCloseSnack={handleCloseSnack}
            setSnack={setSnack}
            setOpenSnack={setOpenSnack}
            reloadList={reloadAfterUpload}
          />
          <DeleteDialog categoria={params.row} myFunction={handleDelete} />
        </Stack>
      ),
    },
    {
      field: "Username",
      headerName: "Utente",
      width: 250,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => (
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {params.value}
        </Typography>
      ),
    },
    {
      field: "Email",
      headerName: "Email",
      width: 260,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => (
        <Typography
          variant="body2"
          color={params.value ? "text.primary" : "text.secondary"}
          noWrap
        >
          {params.value || "—"}
        </Typography>
      ),
    },
    {
      filterable: false,
      field: "*",
      headerName: "Stato",
      width: 100,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => {
        const attivo = params.row.Attivo === 1;
        return (
          <Chip
            size="small"
            label={attivo ? "Attivo" : "Disattivo"}
            sx={{
              bgcolor: attivo ? "#E5F7F0" : "#FDE8EE",
              color: attivo ? "#167A57" : "#B51647",
              fontWeight: 600,
            }}
          />
        );
      },
    },
    {
      field: "ClientiVisibili",
      headerName: "Clienti visibili",
      flex: 1,
      minWidth: 620,
      align: "left",
      headerAlign: "left",
      cellClassName: "clienti-visibili-cell",
      sortable: false,
      renderCell: (params) => {
        const clienti = params.value ? params.value.split("|||") : [];
        const clientiInEvidenza = clienti.slice(0, 5);
        const altriClienti = clienti.length - clientiInEvidenza.length;

        if (clienti.length === 0) {
          return (
            <Typography variant="body2" color="text.secondary">
              Nessun cliente associato
            </Typography>
          );
        }

        return (
          <Stack
            direction="row"
            spacing={0.75}
            alignItems="center"
            justifyContent="flex-start"
            sx={{ width: "100%", minWidth: 0, overflow: "hidden" }}
          >
            {clientiInEvidenza.map((cliente) => {
              const dettaglio = params.row.ClientiDettaglio?.find(
                (item) => item.RagioneSociale === cliente,
              );
              const sedi = dettaglio?.SediVisibili
                ? dettaglio.SediVisibili.split("|||")
                : [];
              const tutteSedi = dettaglio?.TutteSedi === 1;

              return (
                <Tooltip
                  key={cliente}
                  arrow
                  placement="top"
                  title={
                    tutteSedi ? (
                      "Tutte le sedi, incluse quelle aggiunte in futuro"
                    ) : sedi.length > 0 ? (
                      <Box>
                        <Typography variant="caption" sx={{ fontWeight: 700 }}>
                          Sedi visibili
                        </Typography>
                        {sedi.map((sede) => (
                          <Typography
                            key={sede}
                            variant="caption"
                            display="block"
                          >
                            • {sede}
                          </Typography>
                        ))}
                      </Box>
                    ) : (
                      "Nessuna sede associata"
                    )
                  }
                >
                  <Chip
                    label={cliente}
                    size="small"
                    variant="outlined"
                    sx={{
                      maxWidth: 210,
                      borderColor: "#C9DCE5",
                      color: "#315C70",
                      "& .MuiChip-label": {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      },
                    }}
                  />
                </Tooltip>
              );
            })}
            {altriClienti > 0 && (
              <Tooltip
                arrow
                placement="top"
                title={clienti.slice(5).join(", ")}
              >
                <Chip
                  label={`+${altriClienti}`}
                  size="small"
                  sx={{
                    bgcolor: "#E7F2F7",
                    color: "#11526F",
                    fontWeight: 700,
                  }}
                />
              </Tooltip>
            )}
          </Stack>
        );
      },
    },
  ];

  const reloadAfterUpload = async () => {
    try {
      let response = await unsplash.get("utentiClienti", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
      });
      setUtentiClienti(response.data.data);
      setUtentiClientiVisibili(
        response.data.data.filter((a) => a.Attivo === 1),
      );
      setLoading(false);
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleDelete = async (categ) => {
    try {
      await unsplash.delete("utentiClienti", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        data: {
          username: categ.Username,
        },
      });

      setSnack({
        severity: "success",
        messaggio: "Utente eliminato con successo",
      });
      setOpenSnack(true);
      reloadAfterUpload();
    } catch (error) {
      setSnack({
        severity: "error",
        messaggio: "Errore durante l'eliminazione",
      });
      setOpenSnack(true);
      reloadAfterUpload();
    }
    setOpen(false);
  };
  useEffect(() => {
    (() => {
      reloadAfterUpload();
    })();
  }, []);

  const handleSave = async (utenteCliente, operazione) => {
    if (operazione === "new") {
      let nuovoUtente = { ...utenteCliente };

      nuovoUtente.PasswordInChiaro = nuovoUtente.Password;
      delete nuovoUtente.Password;
      try {
        const response = await unsplash.post(
          "utentiClienti",
          {
            utentiClienti: nuovoUtente,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwt")}`,
            },
          },
        );
        if (response.data.conflict || response.data.validationError) {
          setSnack({
            severity: "error",
            messaggio: response.data.message,
          });
          setOpenSnack(true);
          return { success: false, fields: response.data.fields };
        }
        setSnack({
          severity: "success",
          messaggio: "Utente Cliente creato con successo",
        });
        setOpenSnack(true);

        reloadAfterUpload();
        return { success: true, fields: [] };
      } catch {
        setSnack({
          severity: "error",
          messaggio: "Errore durante la creazione",
        });
        setOpenSnack(true);
        return { success: false, fields: [] };
      }
    } else {
      try {
        const response = await unsplash.put(
          "utentiClienti",
          {
            utentiClienti: utenteCliente,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwt")}`,
            },
          },
        );
        if (response.data.conflict) {
          setSnack({
            severity: "error",
            messaggio: response.data.message,
          });
          setOpenSnack(true);
          return { success: false, fields: response.data.fields };
        }
        setSnack({
          severity: "success",
          messaggio: "Utente Cliente aggiornato con successo",
        });
        setOpenSnack(true);

        reloadAfterUpload();
        return { success: true, fields: [] };
      } catch {
        setSnack({
          severity: "error",
          messaggio: "Errore durante l'aggiornamento",
        });
        setOpenSnack(true);
        return { success: false, fields: [] };
      }
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  const filter = (e, tipologia) => {
    let filtroUp = { ...filtro };
    filtroUp[tipologia] = e.target.checked;
    setFiltro(filtroUp);

    let form = utentiClienti;
    if (!filtroUp.attivo) {
      form = form.filter((f) => f.Attivo !== 1);
    }
    if (!filtroUp.disattivo) {
      form = form.filter((f) => f.Attivo !== 0);
    }
    setUtentiClientiVisibili(form);
  };
  function CustomToolbar() {
    const attivi = utentiClienti.filter((utente) => utente.Attivo === 1).length;
    const disattivi = utentiClienti.length - attivi;

    return (
      <GridToolbarContainer
        sx={{
          gap: 1.5,
          px: 2,
          py: 1.5,
          borderBottom: "1px solid #E4E9ED",
          bgcolor: "#FAFCFD",
        }}
      >
        <Grid container direction="row" spacing={1} alignItems="center">
          <Grid item xs={12} sm="auto">
            <GridToolbarQuickFilter
              placeholder="Cerca per nome utente..."
              sx={{
                width: { xs: "100%", sm: 320 },
                "& .MuiInput-root": {
                  px: 1.5,
                  py: 0.5,
                  border: "1px solid #CFD8DC",
                  borderRadius: 1.5,
                  bgcolor: "white",
                },
                "& .MuiInput-root:before, & .MuiInput-root:after": {
                  display: "none",
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm="auto">
            <Stack direction="row" spacing={0.5}>
              <FormControlLabel
                sx={{ m: 0, color: "#11526F" }}
                control={
                  <Checkbox
                    size="small"
                    checked={filtro.attivo}
                    onChange={(e) => filter(e, "attivo")}
                  />
                }
                label={`Attivi (${attivi})`}
              />
              <FormControlLabel
                sx={{ m: 0, color: "#11526F" }}
                control={
                  <Checkbox
                    size="small"
                    name="Disattivi"
                    checked={filtro.disattivo}
                    onChange={(e) => filter(e, "disattivo")}
                  />
                }
                label={`Disattivi (${disattivi})`}
              />
            </Stack>
          </Grid>
        </Grid>
      </GridToolbarContainer>
    );
  }
  return (
    <>
      <GlobalSnackbar
        severity={snack.severity}
        messaggio={snack.messaggio}
        openSnack={openSnack}
        handleCloseSnack={handleCloseSnack}
      />
      <Grid item xs={12}>
        <Card
          sx={{ borderRadius: 2, boxShadow: "0 2px 12px rgba(17,82,111,.08)" }}
        >
          <CardContent sx={{ p: { xs: 2, md: 3 }, "&:last-child": { pb: 3 } }}>
            <>
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ mb: 2.5 }}
                >
                  <Grid item>
                    <Typography
                      variant="h5"
                      sx={{ color: "#153E52", fontWeight: 700 }}
                    >
                      Utenti clienti
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Gestisci accessi, stato e clienti associati
                    </Typography>
                  </Grid>
                  <Grid item>
                    <NewUtenti
                      id="new"
                      utenteCliente={vistaUtenteCliente}
                      saveFunction={handleSave}
                      title="Nuovo Utente"
                      snack={snack}
                      openSnack={openSnack}
                      handleCloseSnack={handleCloseSnack}
                      setSnack={setSnack}
                      setOpenSnack={setOpenSnack}
                    />
                  </Grid>
                </Grid>
                <Box
                  sx={{
                    width: 1,
                    border: "1px solid #E0E6EA",
                    borderRadius: 2,
                    overflow: "hidden",
                  }}
                >
                  <DataGridPro
                    key="utenti-clienti-layout-v3"
                    components={{
                      Toolbar: CustomToolbar,
                      Footer: CustomFooterPersonalized,
                    }}
                    slots={{
                      loadingOverlay: LinearProgress,
                    }}
                    loading={loading}
                    localeText={
                      itIT.components.MuiDataGrid.defaultProps.localeText
                    }
                    rowHeight={52}
                    rows={utentiClientiVisibili}
                    columns={columns}
                    getRowId={(row) => row.Username}
                    autoHeight
                    pageSize={20}
                    rowsPerPageOptions={[20]}
                    disableSelectionOnClick
                    sx={{
                      border: 0,
                      "& .MuiDataGrid-columnHeaders": {
                        bgcolor: "#115B78",
                        color: "white",
                        borderRadius: 0,
                      },
                      "& .MuiDataGrid-columnSeparator": { display: "none" },
                      "& .MuiDataGrid-row:hover": { bgcolor: "#F4F9FB" },
                      "& .MuiDataGrid-cell": { borderColor: "#EDF0F2" },
                      "& .clienti-visibili-cell": {
                        justifyContent: "flex-start",
                        textAlign: "left",
                      },
                      "& .MuiDataGrid-footerContainer": {
                        borderColor: "#E4E9ED",
                        minHeight: 48,
                      },
                    }}
                  />
                </Box>
              </Grid>
            </>
          </CardContent>
        </Card>
      </Grid>
    </>
  );
};

export default UtentiClienti;

/* Creazione Nuovi UtentiClienti */
const NewUtenti = (props) => {
  const [open, setOpen] = useState(false);
  const [clientiAssociati, setClientiAssociati] = useState([]);
  const [loading, setLoading] = useState(true);
  const [confermaPassword, setConfermaPassword] = useState("");
  const [mostraPassword, setMostraPassword] = useState(false);
  const [campiDuplicati, setCampiDuplicati] = useState([]);
  const [openCambioPassword, setOpenCambioPassword] = useState(false);
  const [nuovaPassword, setNuovaPassword] = useState("");
  const [confermaNuovaPassword, setConfermaNuovaPassword] = useState("");
  const [mostraNuovaPassword, setMostraNuovaPassword] = useState(false);
  const [utenteCliente, setUtenteCliente] = useState({
    Username: "",
    Cliente: "",
    Email: "",
    Dettaglio: 0,
    Attivo: 0,
  });

  const column = [
    {
      filterable: false,
      field: "Actions",
      headerName: "Azioni",
      hide: false,
      width: 92,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <Stack direction="row">
          <DialogClienti
            reloadData={() => reloadData()}
            id="edit"
            utente={params.row}
            saveFunction={handleSave}
            clientiAssociati={clientiAssociati.map((elm) => elm.Cliente)}
            cliente={props.utenteCliente.Cliente}
            title="Modifica Cliente"
          />
          <IconButton
            aria-label="Elimina associazione"
            size="small"
            onClick={async () => {
              try {
                await unsplash.delete("utentiClienti", {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem("jwt")}`,
                  },
                  data: {
                    id: params.row.ID,
                  },
                });
                //modifica chiamata con nuova tabella relazionele REL_UTENTICLIENTI_SEDI
                reloadData();

                props.setSnack({
                  severity: "success",
                  messaggio: "Cliente eliminato con successo",
                });
                props.setOpenSnack(true);
              } catch (error) {
                props.setSnack({
                  severity: "error",
                  messaggio: "Errore durante l'eliminazione",
                });
                props.setOpenSnack(true);
              }
            }}
          >
            <Delete
              style={{ height: "1.25rem", width: "1.25rem", color: "#D81B52" }}
            />
          </IconButton>
        </Stack>
      ),
    },
    {
      field: "RagioneSociale",
      headerName: "Cliente",
      flex: 1,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => {
        const tutteSedi = params.row.TutteSedi === 1;
        const sedi = params.row.SediVisibili
          ? params.row.SediVisibili.split("|||")
          : [];
        return (
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {params.value}
            </Typography>
            <Tooltip
              arrow
              placement="top"
              title={
                tutteSedi ? (
                  "Tutte le sedi, incluse quelle aggiunte in futuro"
                ) : sedi.length > 0 ? (
                  <Box>
                    <Typography variant="caption" sx={{ fontWeight: 700 }}>
                      Sedi visibili
                    </Typography>
                    {sedi.map((descrizione) => (
                      <Typography
                        key={descrizione}
                        variant="caption"
                        display="block"
                      >
                        • {descrizione}
                      </Typography>
                    ))}
                  </Box>
                ) : (
                  "Nessuna sede associata"
                )
              }
            >
              <Chip
                size="small"
                label={
                  tutteSedi
                    ? "Tutte le sedi"
                    : `${sedi.length} ${sedi.length === 1 ? "sede" : "sedi"}`
                }
                sx={{
                  bgcolor: tutteSedi || sedi.length > 0 ? "#E7F2F7" : "#F1F3F4",
                  color: tutteSedi || sedi.length > 0 ? "#11526F" : "#66757D",
                  fontWeight: 600,
                }}
              />
            </Tooltip>
          </Stack>
        );
      },
    },
  ];

  const handleClickOpen = async () => {
    if (props.id === "edit") {
      setUtenteCliente({
        Username: props.utenteCliente.Username,
        Attivo: props.utenteCliente.Attivo,
        Email: props.utenteCliente.Email,
        Dettaglio: props.utenteCliente.Dettaglio,
      });
      let res = await unsplash.get("utentiClienti", {
        //ricarico i valori
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        params: {
          utente: props.utenteCliente.Username,
        },
      });
      setClientiAssociati(res.data.data);
      setLoading(false);
    } else if (props.id === "new") {
      setUtenteCliente(newUtenteCliente);
    }
    setOpen(true);
    /* try {
      let response = await unsplash.get("clienti", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        params: { all: "yes" },
      });
      const cli = response.data.data;
      setClienti(response.data.data);
      if (props.id !== "new") {
        setClienteSel(
          response.data.data?.filter(
            (c) => c.ID === props.utenteCliente.Cliente
          )
        );
        
      }
    } catch (error) {
      console.error(error.message);
    }
    if (props.id === "edit") {
      setUtenteCliente({
        Username: props.utenteCliente.Username,
        Attivo: props.utenteCliente.Attivo,
      });
      let res = await unsplash.get("utentiClienti", {
        //ricarico i valori
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        params: {
          relUtente: props.utenteCliente.Username,
        },
      });
      setClientiAssociati(res.data.data);
    } else if (props.id === "new") {
      setUtenteCliente(newUtenteCliente);
      setClienteSel(null);
    }
    setOpen(true); */
  };
  const handleClose = () => {
    setUtenteCliente(newUtenteCliente);
    setConfermaPassword("");
    setMostraPassword(false);
    setCampiDuplicati([]);
    setOpen(false);
  };
  const handleChange = (e) => {
    let copiaUtenteCliente = { ...utenteCliente };
    if (e.target.name === "Password") {
      copiaUtenteCliente[e.target.name] = e.target.value;
    } else {
      copiaUtenteCliente[e.target.name] = e.target.value;
    }

    setUtenteCliente(copiaUtenteCliente);
    if (
      e.target.name === "Username" ||
      e.target.name === "Email" ||
      e.target.name === "Password"
    ) {
      setCampiDuplicati((campi) =>
        campi.filter((campo) => campo !== e.target.name),
      );
    }
  };
  const handleSave = async () => {
    if (
      props.id === "new" &&
      (!utenteCliente.Password ||
        !confermaPassword ||
        utenteCliente.Password !== confermaPassword ||
        !Object.values(
          getPasswordChecks(
            utenteCliente.Password,
            utenteCliente.Username,
            utenteCliente.Email,
          ),
        ).every(Boolean))
    ) {
      return;
    }
    const result = await props.saveFunction(utenteCliente, props.id);
    if (result?.success) {
      handleClose();
    } else if (result?.fields) {
      setCampiDuplicati(result.fields);
    }
  };

  const passwordNonCoincidenti =
    props.id === "new" &&
    confermaPassword.length > 0 &&
    utenteCliente.Password !== confermaPassword;
  const passwordChecks = getPasswordChecks(
    utenteCliente.Password,
    utenteCliente.Username,
    utenteCliente.Email,
  );
  const passwordSicura = Object.values(passwordChecks).every(Boolean);
  const creazioneNonValida =
    props.id === "new" &&
    (!utenteCliente.Password ||
      !confermaPassword ||
      utenteCliente.Password !== confermaPassword ||
      !passwordSicura);

  const handleGeneraPassword = () => {
    const password = generaPasswordSicura();
    setUtenteCliente((utente) => ({ ...utente, Password: password }));
    setConfermaPassword(password);
    setMostraPassword(true);
    setCampiDuplicati((campi) => campi.filter((campo) => campo !== "Password"));
  };

  const nuovaPasswordChecks = getPasswordChecks(
    nuovaPassword,
    utenteCliente.Username,
    utenteCliente.Email,
  );
  const nuovaPasswordValida =
    Object.values(nuovaPasswordChecks).every(Boolean) &&
    nuovaPassword === confermaNuovaPassword;

  const handleCloseCambioPassword = () => {
    setOpenCambioPassword(false);
    setNuovaPassword("");
    setConfermaNuovaPassword("");
    setMostraNuovaPassword(false);
  };

  const handleGeneraNuovaPassword = () => {
    const password = generaPasswordSicura();
    setNuovaPassword(password);
    setConfermaNuovaPassword(password);
    setMostraNuovaPassword(true);
  };

  const handleCambioPassword = async () => {
    if (!nuovaPasswordValida) return;
    try {
      const response = await unsplash.put(
        "utentiClienti",
        {
          cambioPassword: {
            Username: utenteCliente.Username,
            PasswordInChiaro: nuovaPassword,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        },
      );
      if (response.data.validationError || !response.data.updated) {
        throw new Error(response.data.message);
      }
      props.setSnack({
        severity: "success",
        messaggio: "Password aggiornata con successo",
      });
      props.setOpenSnack(true);
      handleCloseCambioPassword();
    } catch (error) {
      props.setSnack({
        severity: "error",
        messaggio: error.message || "Errore durante il cambio password",
      });
      props.setOpenSnack(true);
    }
  };

  const reloadData = async () => {
    let res = await unsplash.get("utentiClienti", {
      //ricarico i valori
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      params: {
        utente: props.utenteCliente.Username,
      },
    });
    setClientiAssociati(res.data.data);
    if (props.reloadList) {
      props.reloadList();
    }
  };

  return (
    <>
      {props.id === "edit" ? (
        <IconButton
          id={props.id}
          aria-label="Modifica utente"
          onClick={handleClickOpen}
          size="small"
        >
          <EditIcon
            style={{ height: "1.25rem", width: "1.25rem", color: "#2265B1" }}
          />
        </IconButton>
      ) : (
        <Button
          startIcon={<Add />}
          onClick={handleClickOpen}
          id={props.id}
          sx={{ color: "white" }}
          variant="outlined"
          className="ButtonMiller"
        >
          Aggiungi
        </Button>
      )}

      <Grid
        container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth={true}
          maxWidth="lg"
          scroll="paper"
          PaperProps={{
            sx: {
              borderRadius: 2,
              maxWidth: 1080,
              maxHeight: "calc(100vh - 48px)",
              m: 2,
              overflow: "hidden",
            },
          }}
        >
          <DialogTitle
            sx={{
              px: { xs: 2.5, md: 3 },
              pt: 3,
              pb: 2.5,
              borderBottom: "1px solid #E4E9ED",
              flexShrink: 0,
            }}
          >
            <Typography variant="h5" sx={{ color: "#153E52", fontWeight: 700 }}>
              {props.title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {props.id === "edit"
                ? "Modifica i dati dell’account e i clienti associati"
                : "Inserisci i dati del nuovo account cliente"}
            </Typography>
          </DialogTitle>

          <DialogContent
            dividers={false}
            sx={{
              p: { xs: "24px !important", md: "28px 24px !important" },
              minHeight: 0,
              overflowY: "auto",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  disabled={props.id === "new" ? false : true}
                  value={utenteCliente.Username}
                  id="outlined-basic"
                  label="Utente"
                  name="Username"
                  onChange={handleChange}
                  fullWidth
                  error={campiDuplicati.includes("Username")}
                  helperText={
                    campiDuplicati.includes("Username")
                      ? "Questo nome utente esiste già"
                      : " "
                  }
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  value={utenteCliente.Email}
                  id="outlined-basic"
                  label="Email"
                  name="Email"
                  onChange={handleChange}
                  fullWidth
                  error={campiDuplicati.includes("Email")}
                  helperText={
                    campiDuplicati.includes("Email")
                      ? "Questa email è già associata a un utente"
                      : " "
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 2,
                    px: 2,
                    py: 1.25,
                    border: "1px solid #E0E6EA",
                    borderRadius: 1.5,
                    bgcolor: "#FAFCFD",
                  }}
                >
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      Limita ai dati del referente
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Mostra solo i dati associati all’email di questo account
                    </Typography>
                  </Box>
                  <Switch
                    checked={utenteCliente?.Dettaglio === 1}
                    onChange={(e) =>
                      setUtenteCliente({
                        ...utenteCliente,
                        Dettaglio: e.target.checked ? 1 : 0,
                      })
                    }
                  />
                </Box>
              </Grid>

              {props.id === "new" ? (
                <>
                  <Grid item xs={12} md={6}>
                    <TextField
                      type={mostraPassword ? "text" : "password"}
                      value={utenteCliente.Password}
                      id="outlined-basic"
                      label="Password"
                      name="Password"
                      onChange={handleChange}
                      fullWidth
                      error={campiDuplicati.includes("Password")}
                      helperText={
                        campiDuplicati.includes("Password")
                          ? "La password non rispetta i requisiti"
                          : " "
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label={
                                mostraPassword
                                  ? "Nascondi password"
                                  : "Mostra password"
                              }
                              onClick={() =>
                                setMostraPassword((value) => !value)
                              }
                              edge="end"
                            >
                              {mostraPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      type={mostraPassword ? "text" : "password"}
                      value={confermaPassword}
                      id="conferma-password"
                      label="Conferma password"
                      onChange={(event) =>
                        setConfermaPassword(event.target.value)
                      }
                      fullWidth
                      error={passwordNonCoincidenti}
                      helperText={
                        passwordNonCoincidenti
                          ? "Le password non coincidono"
                          : " "
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label={
                                mostraPassword
                                  ? "Nascondi password"
                                  : "Mostra password"
                              }
                              onClick={() =>
                                setMostraPassword((value) => !value)
                              }
                              edge="end"
                            >
                              {mostraPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        p: 2,
                        border: "1px solid #E0E6EA",
                        borderRadius: 1.5,
                        bgcolor: "#FAFCFD",
                      }}
                    >
                      <Stack
                        direction={{ xs: "column", sm: "row" }}
                        justifyContent="space-between"
                        alignItems={{ xs: "stretch", sm: "center" }}
                        spacing={1.5}
                      >
                        <Box>
                          <Typography variant="body2" sx={{ fontWeight: 700 }}>
                            Requisiti password
                          </Typography>
                          <Stack
                            direction="row"
                            useFlexGap
                            flexWrap="wrap"
                            spacing={1}
                            sx={{ mt: 0.75 }}
                          >
                            {[
                              ["lunghezza", "12+ caratteri"],
                              ["minuscola", "Minuscola"],
                              ["maiuscola", "Maiuscola"],
                              ["numero", "Numero"],
                              ["simbolo", "Simbolo"],
                              ["senzaSpazi", "Senza spazi"],
                              ["datiPersonali", "Diversa dai dati utente"],
                            ].map(([chiave, label]) => (
                              <Typography
                                key={chiave}
                                variant="caption"
                                sx={{
                                  color: passwordChecks[chiave]
                                    ? "#167A57"
                                    : "text.secondary",
                                  fontWeight: passwordChecks[chiave]
                                    ? 700
                                    : 400,
                                }}
                              >
                                {passwordChecks[chiave] ? "✓" : "○"} {label}
                              </Typography>
                            ))}
                          </Stack>
                        </Box>
                        <Button
                          variant="outlined"
                          startIcon={<AutoFixHigh />}
                          onClick={handleGeneraPassword}
                          sx={{ flexShrink: 0 }}
                        >
                          Genera password
                        </Button>
                      </Stack>
                    </Box>
                  </Grid>
                </>
              ) : (
                <Grid item xs={12}>
                  <Button
                    variant="outlined"
                    startIcon={<LockReset />}
                    onClick={() => setOpenCambioPassword(true)}
                  >
                    Cambia password
                  </Button>
                  <Divider sx={{ my: 1 }} />
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    alignItems={{ xs: "stretch", sm: "center" }}
                    justifyContent="space-between"
                    spacing={1.5}
                    sx={{ mt: 2, mb: 1.5 }}
                  >
                    <Box>
                      <Typography
                        variant="h6"
                        sx={{ color: "#153E52", fontWeight: 700 }}
                      >
                        Clienti associati
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {clientiAssociati.length === 1
                          ? "1 cliente visibile"
                          : `${clientiAssociati.length} clienti visibili`}
                      </Typography>
                    </Box>
                    <DialogClienti
                      reloadData={reloadData}
                      id="new"
                      utente={utenteCliente.Username}
                      saveFunction={handleSave}
                      clientiAssociati={clientiAssociati.map(
                        (elm) => elm.Cliente,
                      )}
                      cliente={props.utenteCliente.Cliente}
                      title="Nuovo Cliente"
                    />
                  </Stack>
                </Grid>
              )}
            </Grid>

            {props.id === "edit" ? (
              <Box
                sx={{
                  width: 1,
                  maxHeight: 360,
                  overflow: "auto",
                  border: "1px solid #E0E6EA",
                  borderRadius: 2,
                }}
              >
                <DataGridPro
                  components={{
                    Toolbar: CustomToolbarG,
                    Footer: CustomFooterPersonalized,
                  }}
                  slots={{
                    loadingOverlay: LinearProgress,
                  }}
                  loading={loading}
                  localeText={
                    itIT.components.MuiDataGrid.defaultProps.localeText
                  }
                  rowHeight={52}
                  rows={clientiAssociati}
                  columns={column}
                  getRowId={(row) => row.ID}
                  autoHeight
                  pageSize={20}
                  rowsPerPageOptions={[20]}
                  disableSelectionOnClick
                  hideFooter={clientiAssociati.length <= 20}
                  sx={{
                    border: 0,
                    "& .MuiDataGrid-columnHeaders": {
                      bgcolor: "#115B78",
                      color: "white",
                      borderRadius: 0,
                    },
                    "& .MuiDataGrid-columnSeparator": { display: "none" },
                    "& .MuiDataGrid-row:hover": { bgcolor: "#F4F9FB" },
                    "& .MuiDataGrid-cell": { borderColor: "#EDF0F2" },
                  }}
                />
              </Box>
            ) : (
              <></>
            )}
          </DialogContent>
          <DialogActions
            sx={{
              justifyContent: "flex-end",
              gap: 1,
              px: { xs: 2.5, md: 3 },
              py: 2,
              borderTop: "1px solid #E4E9ED",
              bgcolor: "#FAFCFD",
              flexShrink: 0,
            }}
          >
            <Button
              onClick={handleClose}
              variant="outlined"
              startIcon={<Close />}
            >
              Annulla
            </Button>
            <Button
              onClick={handleSave}
              variant="contained"
              className="ButtonMiller"
              startIcon={<Check />}
              disabled={creazioneNonValida}
            >
              {props.id === "new" ? "Crea utente" : "Salva modifiche"}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openCambioPassword}
          onClose={handleCloseCambioPassword}
          fullWidth
          maxWidth="sm"
          PaperProps={{ sx: { borderRadius: 2, overflow: "hidden" } }}
        >
          <DialogTitle sx={{ px: 3, pt: 3, pb: 2.5 }}>
            <Typography variant="h5" sx={{ color: "#153E52", fontWeight: 700 }}>
              Cambia password
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Imposta una nuova password per {utenteCliente.Username}
            </Typography>
          </DialogTitle>
          <DialogContent sx={{ p: "24px !important" }}>
            <Stack spacing={2}>
              {[
                ["Nuova password", nuovaPassword, setNuovaPassword],
                [
                  "Conferma nuova password",
                  confermaNuovaPassword,
                  setConfermaNuovaPassword,
                ],
              ].map(([label, value, setter]) => (
                <TextField
                  key={label}
                  label={label}
                  value={value}
                  type={mostraNuovaPassword ? "text" : "password"}
                  onChange={(event) => setter(event.target.value)}
                  fullWidth
                  error={
                    label.startsWith("Conferma") &&
                    confermaNuovaPassword.length > 0 &&
                    nuovaPassword !== confermaNuovaPassword
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            setMostraNuovaPassword(
                              (valueAttuale) => !valueAttuale,
                            )
                          }
                          edge="end"
                        >
                          {mostraNuovaPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              ))}
              <Button
                variant="outlined"
                startIcon={<AutoFixHigh />}
                onClick={handleGeneraNuovaPassword}
              >
                Genera password sicura
              </Button>
              <Typography variant="caption" color="text.secondary">
                12+ caratteri, maiuscola, minuscola, numero, simbolo, senza
                spazi e diversa dai dati dell’utente.
              </Typography>
            </Stack>
          </DialogContent>
          <DialogActions sx={{ px: 3, py: 2, bgcolor: "#FAFCFD" }}>
            <Button onClick={handleCloseCambioPassword} variant="outlined">
              Annulla
            </Button>
            <Button
              onClick={handleCambioPassword}
              variant="contained"
              className="ButtonMiller"
              startIcon={<Check />}
              disabled={!nuovaPasswordValida}
            >
              Aggiorna password
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
};

const DialogClienti = (props) => {
  const [open, setOpen] = useState(false);
  const [openSede, setOpenSede] = useState(false);
  const [clienti, setClienti] = useState([]);
  const [clienteSel, setClienteSel] = useState(null);

  const [cliente, setCliente] = useState([]);
  const [tutteSedi, setTutteSedi] = useState(false);

  const [sediAssociate, setSediAssociate] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sedi, setSedi] = useState([]);
  const [sediSel, setSediSel] = useState([]);
  const [sede, setSede] = useState([]);

  const [openSnack, setOpenSnack] = useState(false);
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };
  const [snack, setSnack] = useState({
    severity: "success",
    messaggio: "Salvataggio Effettuato correttamente",
    open: false,
  });

  const column = [
    {
      filterable: false,
      field: "Actions",
      headerName: "Azioni",
      hide: false,
      width: 72,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <>
          <IconButton
            aria-label="Rimuovi sede"
            size="small"
            disabled={tutteSedi}
            onClick={async () => {
              try {
                await unsplash.delete("utentiClienti", {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem("jwt")}`,
                  },
                  data: {
                    sedeRel: params.row.ID,
                  },
                });

                setSnack({
                  severity: "success",
                  messaggio: "Sede eliminata con successo",
                });
                setOpenSnack(true);
              } catch (error) {
                setSnack({
                  severity: "error",
                  messaggio: "Errore durante l'eliminazione",
                });
                setOpenSnack(true);
              }
              loadAllSedi();
              props.reloadData();
            }}
          >
            <Delete
              style={{ height: "1.25rem", width: "1.25rem", color: "#D81B52" }}
            />
          </IconButton>
        </>
      ),
    },
    {
      field: "Descrizione",
      headerName: "Descrizione",
      flex: 1,
      align: "left",
      headerAlign: "left",
      renderCell: (params) => (
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {params.value}
        </Typography>
      ),
    },
  ];

  const loadAllSedi = async () => {
    let responseUtentiClienti = await unsplash.get("utentiClienti", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      params: { relUtente: props.utente.ID },
    });
    setSediAssociate(responseUtentiClienti.data.data);
    setLoading(false);
    const onlyIDSediAssociate = responseUtentiClienti.data.data.map(
      (el) => el.ID_Sedi,
    );

    let responseSedi = await unsplash.get("sedi", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      params: { id: props.utente.Cliente },
    });
    let sediFiltrati = responseSedi.data.data.filter((c) => {
      return onlyIDSediAssociate.indexOf(c.ID) === -1;
    });

    setSedi(sediFiltrati);
  };

  const handleClickOpen = async () => {
    try {
      if (props.id === "edit") {
        setClienteSel(props.utente);
        setTutteSedi(props.utente.TutteSedi === 1);
        loadAllSedi();
      }
      let response = await unsplash.get("clienti", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        params: { all: "yes" },
      });
      const cli = response.data.data;
      let clientiFiltrati = cli.filter((c) => {
        return props.clientiAssociati.indexOf(c.ID) === -1;
      });
      setClienti(clientiFiltrati.filter((el) => el.Cessato === 0));
    } catch (error) {
      console.error(error.message);
    }
    setOpen(true);
  };

  const handleClose = () => {
    setClienteSel(null);
    setCliente([]);
    setOpen(false);
  };
  const handleCloseSede = () => {
    setSediSel([]);
    setSede([]);
    setOpenSede(false);
  };

  const handleTutteSedi = async (checked) => {
    const valorePrecedente = tutteSedi;
    setTutteSedi(checked);
    try {
      await unsplash.put(
        "utentiClienti",
        {
          tutteSedi: {
            ID: props.utente.ID,
            TutteSedi: checked ? 1 : 0,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        },
      );
      props.reloadData();
      setSnack({
        severity: "success",
        messaggio: checked
          ? "Tutte le sedi abilitate"
          : "Selezione puntuale delle sedi ripristinata",
      });
      setOpenSnack(true);
    } catch {
      setTutteSedi(valorePrecedente);
      setSnack({
        severity: "error",
        messaggio: "Errore durante l'aggiornamento delle sedi",
      });
      setOpenSnack(true);
    }
  };

  const handleSaveSedi = async () => {
    try {
      await unsplash.post(
        "utentiClienti",
        {
          relUtente: {
            ID_Rel_UtentiClienti: props.utente.ID,
            ID_Sedi: sede,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        },
      );

      setSnack({
        severity: "success",
        messaggio:
          sede.length === 1
            ? "Sede associata con successo"
            : `${sede.length} sedi associate con successo`,
      });
      setOpenSnack(true);
      handleCloseSede();
      loadAllSedi();
      props.reloadData();
    } catch {
      setSnack({
        severity: "error",
        messaggio: "Errore durante l'associazione delle sedi",
      });
      setOpenSnack(true);
    }
  };
  const handleSave = async () => {
    let nuovoCliente = {
      Utente: props.utente,
      Cliente: cliente,
    };
    try {
      await unsplash.post(
        "utentiClienti",
        {
          clienti: nuovoCliente,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        },
      );

      setSnack({
        severity: "success",
        messaggio:
          cliente.length === 1
            ? "Cliente associato con successo"
            : `${cliente.length} clienti associati con successo`,
      });
      setOpenSnack(true);
    } catch {
      setSnack({
        severity: "error",
        messaggio: "Errore durante la creazione",
      });
      setOpenSnack(true);
    }
    props.reloadData();
    handleClose();
  };

  return (
    <>
      {props.id === "edit" ? (
        <IconButton
          id={props.id}
          aria-label="Modifica associazione"
          onClick={handleClickOpen}
          size="small"
        >
          <EditIcon
            style={{ height: "1.25rem", width: "1.25rem", color: "#2265B1" }}
          />
        </IconButton>
      ) : (
        <Button
          startIcon={<Add />}
          onClick={handleClickOpen}
          id={props.id}
          sx={{ color: "white" }}
          variant="outlined"
          className="ButtonMiller"
        >
          Aggiungi
        </Button>
      )}

      <Grid
        container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth={true}
          maxWidth="md"
          scroll="paper"
          PaperProps={{
            sx: {
              borderRadius: 2,
              maxHeight: "calc(100vh - 48px)",
              m: 2,
              overflow: "hidden",
            },
          }}
        >
          <GlobalSnackbar
            severity={snack.severity}
            messaggio={snack.messaggio}
            openSnack={openSnack}
            handleCloseSnack={handleCloseSnack}
          />
          <DialogTitle
            sx={{
              px: 3,
              pt: 3,
              pb: 2.5,
              borderBottom: "1px solid #E4E9ED",
              flexShrink: 0,
            }}
          >
            <Typography variant="h5" sx={{ color: "#153E52", fontWeight: 700 }}>
              {props.id === "edit" ? "Gestisci cliente" : "Associa clienti"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {props.id === "edit"
                ? "Definisci le sedi che questo utente può visualizzare"
                : "Seleziona uno o più clienti da rendere visibili all’utente"}
            </Typography>
          </DialogTitle>
          <DialogContent
            sx={{
              p: "24px !important",
              minHeight: 0,
              overflowY: "auto",
            }}
          >
            <Grid item xs={12}>
              <Autocomplete
                id={`cliente-${props.id}`}
                multiple={props.id === "new"}
                options={clienti}
                fullWidth
                value={
                  props.id === "new"
                    ? Array.isArray(clienteSel)
                      ? clienteSel
                      : []
                    : clienteSel
                }
                getOptionLabel={(option) => option.RagioneSociale}
                isOptionEqualToValue={(option, value) => option.ID === value.ID}
                onChange={(event, newValue) => {
                  setClienteSel(newValue);
                  if (props.id === "new") {
                    setCliente(newValue.map((item) => item.ID));
                  } else if (newValue) {
                    setCliente([newValue.ID]);
                  }
                }}
                disabled={props.id === "new" ? false : true}
                renderInput={(params) => (
                  <TextField {...params} label="Cliente" />
                )}
              />
            </Grid>

            {props.id === "edit" ? (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 2,
                    mt: 3,
                    p: 2,
                    border: "1px solid #D7E3E9",
                    borderRadius: 1.5,
                    bgcolor: tutteSedi ? "#F1F8FB" : "#FAFCFD",
                  }}
                >
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: 700 }}>
                      Tutte le sedi
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Include automaticamente anche le sedi create in futuro
                    </Typography>
                  </Box>
                  <Switch
                    checked={tutteSedi}
                    onChange={(event) => handleTutteSedi(event.target.checked)}
                  />
                </Box>
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  alignItems={{ xs: "stretch", sm: "center" }}
                  justifyContent="space-between"
                  spacing={1.5}
                  sx={{ mt: 3, mb: 1.5 }}
                >
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{ color: "#153E52", fontWeight: 700 }}
                    >
                      Sedi visibili
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {sediAssociate.length === 1
                        ? "1 sede associata"
                        : `${sediAssociate.length} sedi associate`}
                    </Typography>
                  </Box>
                  <Button
                    onClick={() => setOpenSede(true)}
                    variant="contained"
                    className="ButtonMiller"
                    startIcon={<Add />}
                    disabled={tutteSedi}
                  >
                    Aggiungi sede
                  </Button>
                </Stack>
                <Box
                  sx={{
                    width: 1,
                    maxHeight: 360,
                    overflow: "auto",
                    border: "1px solid #E0E6EA",
                    borderRadius: 2,
                    opacity: tutteSedi ? 0.6 : 1,
                  }}
                >
                  <DataGridPro
                    components={{
                      Toolbar: CustomToolbarG,
                      Footer: CustomFooterPersonalized,
                    }}
                    slots={{
                      loadingOverlay: LinearProgress,
                    }}
                    loading={loading}
                    localeText={
                      itIT.components.MuiDataGrid.defaultProps.localeText
                    }
                    rowHeight={52}
                    rows={sediAssociate}
                    columns={column}
                    getRowId={(row) => row.ID}
                    autoHeight
                    pageSize={20}
                    rowsPerPageOptions={[20]}
                    disableSelectionOnClick
                    hideFooter={sediAssociate.length <= 20}
                    sx={{
                      border: 0,
                      "& .MuiDataGrid-columnHeaders": {
                        bgcolor: "#115B78",
                        color: "white",
                        borderRadius: 0,
                      },
                      "& .MuiDataGrid-columnSeparator": { display: "none" },
                      "& .MuiDataGrid-row:hover": { bgcolor: "#F4F9FB" },
                      "& .MuiDataGrid-cell": { borderColor: "#EDF0F2" },
                    }}
                  />
                </Box>
              </>
            ) : (
              <></>
            )}
          </DialogContent>
          <DialogActions
            sx={{
              justifyContent: "flex-end",
              gap: 1,
              px: 3,
              py: 2,
              borderTop: "1px solid #E4E9ED",
              bgcolor: "#FAFCFD",
              flexShrink: 0,
            }}
          >
            <Button
              onClick={handleClose}
              variant="outlined"
              startIcon={<Close />}
            >
              {props.id === "edit" ? "Chiudi" : "Annulla"}
            </Button>
            {props.id === "new" && (
              <Button
                onClick={handleSave}
                variant="contained"
                className="ButtonMiller"
                startIcon={<Check />}
                disabled={cliente.length === 0}
              >
                {cliente.length > 1
                  ? `Associa ${cliente.length} clienti`
                  : "Associa cliente"}
              </Button>
            )}
          </DialogActions>
        </Dialog>

        <Dialog
          open={openSede}
          onClose={handleCloseSede}
          fullWidth={true}
          maxWidth="sm"
          PaperProps={{ sx: { borderRadius: 2, overflow: "hidden" } }}
        >
          <DialogTitle
            sx={{
              px: 3,
              pt: 3,
              pb: 2.5,
              borderBottom: "1px solid #E4E9ED",
            }}
          >
            <Typography variant="h5" sx={{ color: "#153E52", fontWeight: 700 }}>
              Aggiungi sedi
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Seleziona una o più sedi da rendere visibili per questo cliente
            </Typography>
          </DialogTitle>
          <DialogContent sx={{ p: "24px !important" }}>
            <Grid item xs={12}>
              <Autocomplete
                id="sede-da-associare"
                multiple
                options={sedi}
                fullWidth
                value={sediSel}
                getOptionLabel={(option) => option.Descrizione}
                isOptionEqualToValue={(option, value) => option.ID === value.ID}
                onChange={(event, newValues) => {
                  setSediSel(newValues);
                  setSede(newValues.map((item) => item.ID));
                }}
                renderInput={(params) => <TextField {...params} label="Sede" />}
              />
            </Grid>
          </DialogContent>
          <DialogActions
            sx={{
              justifyContent: "flex-end",
              gap: 1,
              px: 3,
              py: 2,
              borderTop: "1px solid #E4E9ED",
              bgcolor: "#FAFCFD",
            }}
          >
            <Button
              onClick={handleCloseSede}
              variant="outlined"
              startIcon={<Close />}
            >
              Annulla
            </Button>
            <Button
              onClick={handleSaveSedi}
              variant="contained"
              className="ButtonMiller"
              startIcon={<Check />}
              disabled={sede.length === 0}
            >
              {sede.length > 1 ? `Associa ${sede.length} sedi` : "Associa sede"}
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
};

const DeleteDialog = (props) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <IconButton
        aria-label="Elimina utente"
        onClick={handleClickOpen}
        size="small"
      >
        <Delete
          style={{ height: "1.25rem", width: "1.25rem", color: "#D81B52" }}
        />
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ mx: "auto" }}>
          Eliminare l'utente?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Stai per eliminare l'utente <b>{props.categoria.Username}</b>.
            Questa operazione non può essere annullata.
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            px: 3,
          }}
        >
          <Button onClick={handleClose}>annulla</Button>
          <Button onClick={() => props.myFunction(props.categoria)}>
            Conferma
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
